import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  root: {
    width: 640,
    padding: theme.spacing(3),
  },
  header: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontWeight: 500,
    marginBottom: theme.spacing(3),
  },
  subtitle: {
    color: grey[600],
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  description: {
    fontSize: 16,
    paddingTop: theme.spacing(2),
    lineHeight: 2,
  },
  iconButton: {
    minWidth: 40,
    padding: "5px 0",
  },
  image: {
    width: "100%",
    maxHeight: 593,
  },
  cropImagePreview: {
    display: "none",
  },
  container: {
    position: "relative",
  },
  actionButtons: {
    position: "absolute",
    width: 96,
    bottom: "calc(100% + 24px)",
    right: 0,
  },
  resizeSliderMark: {
    background: theme.palette.primary.main,
    height: 4,
    width: 4,
    borderRadius: "50%",
    color: grey[400],
  },
  resizeSliderTrack: {
    height: 4,
  },
  resizeSliderMarkLabel: {
    color: grey[400],
  },
  resizeSliderMarkLabelActive: {
    color: theme.palette.primary.main,
  },
}));
